import {
  isValidTopicDuration,
  parseTopicDurationToSeconds,
} from '../../../shared/topic-validation';

export type DurationRange = 'under_90' | '90_to_120' | '120_to_150' | 'over_150';

export const DURATION_ALL_VALUE = 'all';

export const DURATION_RANGE_OPTIONS: Array<{
  value: DurationRange;
  label: string;
}> = [
  { value: 'under_90', label: '\u0031\u5206\u534a\u5185' },
  { value: '90_to_120', label: '\u0031\u5206\u534a\u002d\u0032\u5206' },
  { value: '120_to_150', label: '\u0032\u5206\u002d\u0032\u5206\u534a' },
  { value: 'over_150', label: '\u0032\u5206\u534a\u4ee5\u4e0a' },
];

export const DURATION_FILTER_OPTIONS: Array<{
  value: DurationRange | typeof DURATION_ALL_VALUE;
  label: string;
}> = [
  { value: DURATION_ALL_VALUE, label: '\u5168\u90e8' },
  ...DURATION_RANGE_OPTIONS,
];

export const getDurationRangeLabel = (range: DurationRange): string =>
  DURATION_RANGE_OPTIONS.find((option) => option.value === range)?.label || range;

export const parseDurationToSeconds = (duration: string): number | null => {
  return parseTopicDurationToSeconds(duration);
};

export const isValidDurationFormat = (duration: string): boolean =>
  isValidTopicDuration(duration);

export const isDurationInRange = (
  duration: string,
  range: DurationRange,
): boolean => {
  const seconds = parseDurationToSeconds(duration);
  // 非法/异常时长不能命中任何筛选区间，避免“3分99秒”出现在所有筛选结果里
  if (seconds === null) return false;

  if (range === 'under_90') return seconds <= 90;
  if (range === '90_to_120') return seconds > 90 && seconds <= 120;
  if (range === '120_to_150') return seconds > 120 && seconds <= 150;
  return seconds > 150;
};

export const isDurationInRanges = (
  duration: string,
  ranges: DurationRange[],
): boolean => {
  if (ranges.length === 0) return true;
  return ranges.some((range) => isDurationInRange(duration, range));
};
